var _path, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyState2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 260,
    height: 210,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M221.317 65.5695c3.296 20.8401-17.002 36.7575-24.584 56.3635-5.391 13.942-4.334 29.824-13.336 41.694-9.894 13.045-23.3 23.435-39.089 27.435-16.767 4.247-34.35 1.744-50.4504-4.753-17.4301-7.033-34.5048-16.947-43.9686-33.345-9.7624-16.916-11.1128-37.395-7.9774-56.663 3.1223-19.1881 10.1795-38.9103 25.4452-50.6836 14.5367-11.2111 35.0222-4.9468 52.7352-9.6114 20.864-5.4944 39.117-26.1112 59.883-20.0464 21.036 6.1438 37.887 27.7566 41.342 49.6099Z",
    fill: "#E1E8FD"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.6436,
    y: 55.583,
    width: 118.623,
    height: 102.679,
    rx: 8,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.6436,
    y: 56.583,
    width: 116.623,
    height: 100.679,
    rx: 7,
    stroke: "#008BFF",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71.6436 63.583c0-3.866 3.134-7 7-7H181.267c3.866 0 7 3.134 7 7v7.6687H71.6436V63.583Z",
    fill: "#E1E8FD",
    stroke: "#008BFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 70.6436,
    y: 55.583,
    width: 118.623,
    height: 102.679,
    rx: 8,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.6436,
    y: 56.583,
    width: 116.623,
    height: 100.679,
    rx: 7,
    stroke: "#008BFF",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    d: "M71.6436 63.583c0-3.866 3.134-7 7-7H181.267c3.866 0 7 3.134 7 7v7.6687H71.6436V63.583Z",
    fill: "#E1E8FD",
    stroke: "#008BFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 102.277,
    cy: 94.9209,
    rx: 2.6361,
    ry: 2.667,
    fill: "#008BFF"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 156.975,
    cy: 94.9209,
    rx: 2.6361,
    ry: 2.667,
    fill: "#008BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m157 126.996-11.312 2.951a63.0117 63.0117 0 0 1-31.097.179L102 126.996",
    stroke: "#008BFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.277 124c-.22 1.333-1.318 4.467-3.9542 6.334M156.976 124c.22 1.333 1.318 4.467 3.954 6.334",
    stroke: "#008BFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m193.221 52.2493 9.885-10.0013M206.401 64.917h-11.862M180.041 50.9155V38.9141",
    stroke: "#FE6968",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.3044 108.589c0 1.755-1.4044 3.167-3.1246 3.167s-3.1246-1.412-3.1246-3.167 1.4044-3.167 3.1246-3.167 3.1246 1.412 3.1246 3.167Z",
    stroke: "#008BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m61.0964 136.926 1.5536 4.423 4.0395.158-3.9541 1.931-1.639 4.156-1.3266-4.156-2.9656-.965 2.9656-.966 1.3266-4.581ZM201.207 116.924l2.175 6.082 5.656.217-5.536 2.656-2.295 5.713-1.857-5.714-4.152-1.327 4.152-1.329 1.857-6.298ZM200.193 84.1234l-.081 3.2511 2.702 1.2331-3.181.1206-2.18 2.1855.167-3.0172-1.766-1.4459 2.262.2166 2.077-2.5438ZM61.566 72.493l-.5413 2.2649 1.5584 1.076-2.0709-.1683-1.7355 1.3538.5612-2.0947-.922-1.1503 1.427.3309 1.7231-1.6123Z",
    fill: "#008BFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 54.6436,
    y: 47.583,
    width: 150.623,
    height: 134.679,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.341176 0 0 0 0 0.498039 0 0 0 0 0.996078 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3314_15325"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.341176 0 0 0 0 0.498039 0 0 0 0 0.996078 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_3314_15325",
    result: "effect2_dropShadow_3314_15325"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3314_15325",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 54.6436,
    y: 47.583,
    width: 150.623,
    height: 134.679,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.341176 0 0 0 0 0.498039 0 0 0 0 0.996078 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3314_15325"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.341176 0 0 0 0 0.498039 0 0 0 0 0.996078 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_3314_15325",
    result: "effect2_dropShadow_3314_15325"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect2_dropShadow_3314_15325",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(28.5 16)",
    d: "M0 0h202v164H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState2);
export default __webpack_public_path__ + "static/media/EmptyState2.0fc7091d430f3eee5a2ad1014f0aa3f6.svg";
export { ForwardRef as ReactComponent };